//** Utilities */
import {
  formatCurrency,
  formatCurrencyNoDecimal,
} from "../utilities/numericFormat.js";

const RISK_TYPES = {
  LIFE: "LIF",
  CRITICAL_ILLNESS: "CI",
  UNABLE_TO_WORK: "PUW",
};

function totalCoverData(inputData) {
  const tableData = {
    rows: inputData.map((data, index) => ({
      row: [
        { value: `year ${index + 1}`, align: "left" },
        { value: `${data.age}`, align: "left" },
        { value: "0", align: "left", hidden: true },
        {
          value: `$${data.monthlyPremium.toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`,
          align: "left",
          frequency: "monthly",
        },
        {
          value: `$${data.annualPremium.toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`,
          align: "left",
          frequency: "annual",
        },
      ],
    })),
  };

  return [tableData];
}

const individualCoverData = (inputData) => {
  const projections = inputData.projections;

  const tableData = {
    rows: projections.map((data, index) => ({
      row: [
        { value: `year ${index + 1}`, align: "left" },
        { value: `${data.age}`, align: "left" },
        {
          value: `$${data.sumInsured.toLocaleString("en-US", {
            minimumFractionDigits: 0,
          })}`,
          align: "left",
        },
        {
          value: `$${data.monthlyPremium.toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`,
          align: "left",
          frequency: "monthly",
        },
        {
          value: `$${data.annualPremium.toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`,
          align: "left",
          frequency: "annual",
        },
      ],
    })),
  };

  return [tableData];
};

export const premiumProjectionResponseTableMapping = (inputData) => {
  const response = {};
  if (inputData == null) return response;

  response.applicants = [];

  // response.projectionYearlyRate = inputData.projectionYearlyRate;
  // response.projectionYearlyRateDisplay =
  //   parseFloat(inputData.projectionYearlyRate) * 100;

  const insuredProjections = inputData?.insuredProjections;

  insuredProjections.map((applicant, index) => {
    //* Loop over the applicants and extract
    //* * Total Cover
    //* * Life Cover
    //* * Critical Illness Cover (if there is CI)
    //* * Unable to work Cover (if there is PUW)

    const covers = applicant.covers; //? all the covers

    //* Extract Critical Illness
    const ciCover = covers.find(
      (item) => item.riskType === RISK_TYPES.CRITICAL_ILLNESS
    );

    //* Extract Permanently Unable to Work.
    const puwCover = covers.find(
      (item) => item.riskType === RISK_TYPES.UNABLE_TO_WORK
    );

    //* Check if they exist on the cover.
    const isCICover = !!ciCover;
    const isPUWCover = !!puwCover;

    const person = {
      isCICover: isCICover,
      isPUWCover: isPUWCover,
      showLifeCover: isCICover || isPUWCover,
      totalProjections: totalCoverData(applicant.totalProjections),
      lifeCover: individualCoverData(
        covers.find((item) => item.riskType === RISK_TYPES.LIFE)
      ),
      ...(isCICover === true && {
        criticalIllnessCover: individualCoverData(ciCover),
      }),
      ...(isPUWCover === true && {
        unableToWorkCover: individualCoverData(puwCover),
      }),
    };

    const applicantDetails = {
      ...(index === 0 && { personOne: person }),
      ...(index === 1 && { personTwo: person }),
    };

    //* We purposely add these two values to each applicants details as it is used in the disclaimer note.
    applicantDetails.projectionYearlyRate = inputData.projectionYearlyRate;
    applicantDetails.projectionYearlyRateDisplay =
      parseFloat(inputData.projectionYearlyRate) * 100;

    response.applicants.push(applicantDetails);
  });

  return response;
};
